import graphqlService from "@/services/graphql.service";
import { buildQuery } from "@/graphql/builders/query.builder";
import { tarifsQueryTypeMap } from "@/graphql/type_maps/type.maps";
import { fragmentTarifsForCatalog } from "@/graphql/fragments/query/tariffs.fragments";

async function fetchTariffCatalog({ isActive, isSubscribable, price, validityMonths, requiredFeatureValues, campaignKey } = {}) {
    const variables = {};

    if (isActive !== undefined) {
        variables.is_active = isActive;
    }

    if (isSubscribable !== undefined) {
        variables.is_subscribable = isSubscribable;
    }

    if (price !== undefined) {
        variables.price = price;
    }

    if (validityMonths !== undefined) {
        variables.validity_months = validityMonths;
    }

    if (Array.isArray(requiredFeatureValues) && requiredFeatureValues.length) {
        variables.required_feature_values = requiredFeatureValues;
    }

    if (campaignKey !== undefined) {
        variables.campaign_key = campaignKey;
    }

    const { query } = buildQuery({
        fragment: fragmentTarifsForCatalog,
        field: "tarifs",
        variables,
        typeMap: tarifsQueryTypeMap,
    });

    const data = await graphqlService.requestGraphql({ query, variables });
    return Array.isArray(data?.tarifs) ? data.tarifs : [];
}

export default { fetchTariffCatalog };
